

































import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "../../event-bus";
import axios from "axios";

@Component({})
export default class RestorePasswordForm extends Vue {
  private login = '';

  created() {
    document.title = this.$t('SCDB') + " | " + this.$t('Восстановление пароля');
  }

  private handleSubmit() {
    //@ts-ignore
    let attemptionToChangePassword = +this.$cookie.get('attemptionToChangePassword') || 0;
    if(attemptionToChangePassword <= 5)
    {
      attemptionToChangePassword += 1;
      //@ts-ignore
      this.$cookie.set("attemptionToChangePassword", attemptionToChangePassword, { expires: '30m' });
      
      EventBus.$emit("showThrobber");
      axios.post('/auth/password', { login: this.login })
            .then(response => {
                EventBus.$emit('success', { msg: response.data });                
            })
            .catch(error => {
              EventBus.$emit("error", { msg: error.data });
            }).finally(() => {
              EventBus.$emit('hideThrobber');
            });
    } else {
      EventBus.$emit('error', { msg: this.$t('Превышено количество попыток запроса изменения пароля!') });
    }    

    this.$router.push('/login');
  }
}
